import { Model } from "./model";

import { Language } from "./language.model";

export class Country extends Model {
    id: number;
    name: string;
    flag: number;
    country_challenges_enabled: number;
    languages?: Language[];
}


// WEBPACK FOOTER //
// ./src/models/country.model.ts